export default __webpack_public_path__ + "static/media/Alchemy_Logo.992f86b6.png";